import React, { FC, useContext } from 'react';
import { AccessLevel } from '@dev/ee-api/ee-api-models';
import { SimplePopover } from '@dev/ee-components';
import { isEmpty } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { isLogsScreen } from '@api/components/Logs/helperFunctions';
import { parseUrlParams } from '@api/services/tools/handleUrlParams';
import { getAccount } from '@api/store/account/types';
import { LogTypesString } from '@api/store/logs/types';

import { GlobalFilterOptionsContext } from '../../..';
import { DropdownFilterType } from '../../../LogsFiltersBarInterfaces';
import { useCampaignPopoverOptions } from '@api/components/Logs/hooks/useCampaignPopoverOptions';
import { TrimLengthWrapper } from '@api/components/Logs/assets/styledComponents';

export const CampaignFilter: FC<DropdownFilterType> = ({ selectedCampaign }: DropdownFilterType): JSX.Element => {
    const { t } = useTranslation();
    const {
        GeneralInfo: { AccountAccessLevel },
    } = useSelector(getAccount);
    const { onClicks, updateFilters, logScreenType, availableFilters } = useContext(GlobalFilterOptionsContext);
    const location = useLocation();

    const { campaign } = parseUrlParams(location.search);

    const campaignsToShow = useCampaignPopoverOptions();

    const pickedCampaign = selectedCampaign ?? (campaign as string);

    const enabledCampaignFilter =
        isLogsScreen(LogTypesString.EMAIL, logScreenType) &&
        AccountAccessLevel.includes(AccessLevel.ViewCampaigns) &&
        !isEmpty(campaignsToShow);

    const onCampaignFilterClick = (
        _event: React.MouseEvent<HTMLInputElement, MouseEvent>,
        campaign: { value: string; label: string }
    ): void => {
        const isAll = campaign.value === 'all';
        const selectedCampaign = isAll ? null : campaign.value;

        const updatedFilters = {
            channel: null,
            campaign: selectedCampaign,
            statuses: null,
        };
        updateFilters(updatedFilters);

        onClicks?.campaignFilter(_event, campaign);
    };
    if (!(availableFilters?.campaign ?? true) || !enabledCampaignFilter) {
        return <></>;
    }

    return (
        <TrimLengthWrapper>
            <SimplePopover
                type="noborder"
                value={pickedCampaign}
                options={campaignsToShow}
                onItemClick={onCampaignFilterClick}
                defaultPlaceholder={t('campaign')}
                maxHeight={400}
                listItemWidth="400px"
                listItemMaxLines={3}
            />
        </TrimLengthWrapper>
    );
};
